import { FC } from 'react';
import { NakedButton } from '@cb/apricot-react';
import { Grid } from '@mui/material';
import { styled } from '@mui/system';
import ArticleIcon from '@mui/icons-material/Article';

import { ISubmitHistory, ISummary, TAIForm, TAIFormSubmit } from 'src/types';
import { formatDate } from 'src/utils';

const SubmitList = styled('ul')`
  list-style: none;
  padding-left: 8px;
`;

const ViewButton = styled(NakedButton)`
  padding: 0 0 0 8px;
`;

interface SubmitHistoryProps {
  school: ISummary;
  onViewSubmit: (submit: ISubmitHistory) => void;
}

const SubmitHistory: FC<SubmitHistoryProps> = ({ school, onViewSubmit }) => {
  if (!school.submissionHistory?.length) {
    return (
      <Grid item xs={12}>
        <div className="cb-card-desc cb-align-right">Not submitted yet</div>
      </Grid>
    );
  }

  return (
    <SubmitList>
      {school.submissionHistory?.map((submit) => (
        <li className="display-flex align-items-xs-center" key={submit.time}>
          <ArticleIcon />
          <ViewButton onClick={() => onViewSubmit(submit)}>View: {formatDate(submit.time)}</ViewButton>
        </li>
      ))}
    </SubmitList>
  );
};

export default SubmitHistory;
